export const calculateIndentation = (indentation: number) => indentation * 24 + 16;
